import React from "react";

export const AICategorised = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.41679"
        y="2.41667"
        width="19.1667"
        height="19.1667"
        rx="9.58333"
        fill="white"
      />
      <rect
        x="2.41679"
        y="2.41667"
        width="19.1667"
        height="19.1667"
        rx="9.58333"
        stroke="#F3F3F5"
        stroke-width="0.833333"
      />
      <rect
        x="2.41679"
        y="2.41667"
        width="19.1667"
        height="19.1667"
        rx="9.58333"
        stroke="url(#paint0_linear_6844_3641)"
        stroke-width="0.833333"
      />
      <path
        d="M15.0255 13.3779C15.4048 14.4987 16.0729 14.9768 17.0001 15.252C15.928 15.5905 15.3327 16.0566 15.213 17.2344C14.8078 16.1337 14.1907 15.6156 13.2521 15.4326C14.2894 14.9963 14.7469 14.5133 15.0255 13.3779ZM11.1847 6.76562C11.8539 9.27864 13.2508 10.4237 15.2443 11.1621C12.8442 11.7483 11.4705 12.6833 11.0372 15.248C10.3083 12.7759 9.03134 11.5497 7.00012 11.0117C9.33755 10.2062 10.4093 9.21426 11.1847 6.76562Z"
        fill="url(#paint1_linear_6844_3641)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6844_3641"
          x1="10.0716"
          y1="4.56204"
          x2="23.0203"
          y2="28.3701"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E693BB" />
          <stop offset="0.405909" stop-color="#763EF3" />
          <stop offset="0.695572" stop-color="#6731F9" />
          <stop offset="1" stop-color="#4A23B2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6844_3641"
          x1="11.0358"
          y1="8.10669"
          x2="17.9793"
          y2="20.3016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E693BB" />
          <stop offset="0.405909" stop-color="#763EF3" />
          <stop offset="0.695572" stop-color="#6731F9" />
          <stop offset="1" stop-color="#4A23B2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
